export default __webpack_public_path__ + "static/media/TrendsFlat.f651302b.svg";